import { render, staticRenderFns } from "./finTaxAgreementIndex.vue?vue&type=template&id=71dff807&"
import script from "./finTaxAgreementIndex.vue?vue&type=script&lang=js&"
export * from "./finTaxAgreementIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports